module.exports = __webpack_public_path__ + "img/characters.1b8201f5.png";